// extracted by mini-css-extract-plugin
export default {"divBoxContent":"ContentBox_divBoxContent__cULMK","headLabel":"ContentBox_headLabel__8uVl+"};